module.exports = __webpack_public_path__ + "img/calendar-month-fill.62bc40d7.svg";